// extracted by mini-css-extract-plugin
export default {"text":"FindingOpponent2_text__4arwG","text_vs":"FindingOpponent2_text_vs__Oveo1"};